<template>
  <div class="industry pt-[40px]">
    <div class="mx-auto w-[1200px]">
      <a-breadcrumb :separator="separator">
        <a-breadcrumb-item>
          <nuxt-link to="/">
            {{ $t('you-yan') }}
          </nuxt-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          <nuxt-link to="/academy">
            {{ $t('mo-fa-xue-yuan') }}
          </nuxt-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>{{ $t('ke-hu-an-li') }}</a-breadcrumb-item>
      </a-breadcrumb>
    </div>

    <div class="mx-auto w-[1200px]">
      <div class="grid grid-cols-4 pt-[28px] gap-[15px]">
        <template v-for="(item, index) in data?.data?.results" :key="item.id">
          <ContentBaseCard
            v-if="openMore ? true : index < MAX_COUNT"
            :data="item"
            :link="{
              name: PageKey.CASE_DETAIL,
              params: {
                // id: item.id,
                post: item.path_url ? item.path_url : item.id,
              },
            }"
            @go="goLink"
          >
            <template #title>
              <span class="text-14 line-clamp-2 text-font-1 title h-[40px]">
                {{ item.title }}
              </span>
            </template>
          </ContentBaseCard>
        </template>
      </div>
      <a-spin :spinning="status === 'pending'"></a-spin>
      <div
        v-if="(data?.data?.results.length || 0) > MAX_COUNT"
        class="see-more"
        @click="toggleShow"
      >
        <template v-if="!openMore">
          <span>{{ $t('cha-kan-geng-duo') }}</span>
          <iconpark-icon name="arrowdown"></iconpark-icon>
        </template>
        <template v-else>
          <span>{{ $t('shou-qi') }}</span>
          <iconpark-icon class="rotate-180" name="arrowdown"></iconpark-icon>
        </template>
      </div>
      <Bottom
        class="mt-[42px]"
        :trackParams="{
          source: '客户案例集合页',
        }"
        :title="$t('cheng-wei-he-zuo-huo-ban')"
        :desc="
          $t(
            'wo-men-qi-dai-he-geng-duo-de-you-xiu-tuan-dui-gong-tong-tan-suo-aigc3d-shi-pin-chuang-zuo-zhi-dian',
          )
        "
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import Bottom from '~/features/publicize/bottom.vue';
import ContentBaseCard from '~/components/content/baseCard.vue';
import { getCaseInfo, getCaseList } from '~/api';
import type { IGetCaseItem } from '~/api/interface/publicize';
import { useWatchPageSeoData } from '~/hooks/useSeo';
import { PageKey } from '~/constants/page';

const separator = h('iconpark-icon', { name: 'breadcrumb-separator', size: 10 });

provideResourceLocation({
  source: SOURCE.CASE,
});

const openMore = ref(false);
const MAX_COUNT = 8;
const pagination = ref({
  page: 1,
  page_size: 100,
});

const goLink = (item: IGetCaseItem) => {
  trackEvent(TRACK_EVENT.CLICK_CASE_DETAIL, {
    source: `${PUBLICIZE_FORM.OTHER}-${item.title}`,
    customer: item.customer_name,
    position: '客户案例集合页',
  });
};

const toggleShow = () => {
  openMore.value = !openMore.value;
};

const { data: caseInfoData } = useAsyncData(getCaseInfo);

const caseInfo = computed(() => caseInfoData.value?.data);

useWatchPageSeoData(caseInfo);

const { data, status } = useAsyncData(() => getCaseList(pagination.value));
</script>

<style lang="scss" scoped>
.banner-title {
  color: var(--purple-10);
}
.industry {
  .test-btn {
    @apply w-[278px]  rounded-[20px] h-[44px] text-[16px];
    box-shadow: 0px 13px 34px 0px rgba(102, 97, 194, 0.23);
  }
  .see-more {
    @apply w-[180px] h-[36px] gap-[5px] mt-[40px] cursor-pointer text-font-1 rounded-full mx-auto flex-y-center justify-center;
    &:hover {
      @apply text-primary;
    }
  }
}
.industry-banner {
  @apply h-[240px] pt-0;
}
</style>
